import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { ref } from 'vue';

dayjs.extend(duration)
export const formattedDate = (date, param = {}) => {
  if (param.short){
    return dayjs(date).format('DD MMM YYYY')
  }
  if (param.time){
    return dayjs(date).format('H:m, DD MMM YYYY')
  }
  return dayjs(date).format('DD MMMM YYYY')
}

export const humanizeText = (text) => {
  const words = text.split('_');
  const humanizedText = words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return humanizedText;
}

export const setStatusColor = (status) => {
  switch (status) {
    case "processing":
      return "badge-light-warning"
    case "reviewing":
      return "badge-light-primary"
    case "verified":
      return "badge-light-success"
    default:
      return "badge-light-light disabled"
  }
}

export const getAge = (dob) =>{
  let today = new Date();
  let birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  let displayAge = ''
  if (age < 1){ // if age 0
    let nowJs = dayjs(new Date())
    let dobJs = dayjs(new Date(dob))
    let diff = dayjs.duration(nowJs.diff(dobJs))
    let month = diff.months()
    age = month/12
    age = Math.round(age * 100) / 100
    switch (age) {
      case 0.08:
        displayAge = '1 month'
        break;
      case 0.17:
        displayAge = '2 months'
        break;
      case 0.25:
        displayAge = '3 months'
        break;
      case 0.33:
        displayAge = '4 months'
        break;
      case 0.42:
        displayAge = '5 months'
        break;
      case 0.50:
        displayAge = '6 months'
        break;
      case 0.58:
        displayAge = '7 months'
        break;
      case 0.67:
        displayAge = '8 months'
        break;
      case 0.75:
        displayAge = '9 months'
        break;
      case 0.83:
        displayAge = '10 months'
        break;
      case 0.92:
        displayAge = '11 months'
        break;
      case 1:
        displayAge = '1'
        break;
      default:
        break;
    }
  }
  if (displayAge == '') return age + ' years old'
  return displayAge
}

export const getAgeFromRange = (dob, from) =>{
  let today = new Date(from);
  let birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export const priceFormat = (price) =>{
  if (price == 0){
    return 'Free'
  }
  return new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(
    price,
  )
}

export const swalError = (errorInfo, isHtml = false) => {
  let text = errorInfo;
  let requestId = null;

  if (typeof errorInfo === 'object' && errorInfo !== null) {
      requestId = errorInfo.requestId;
      
      if (typeof errorInfo.error === 'string') {
          text = errorInfo.error;
      } else if (errorInfo.result) {
          text = errorInfo.result;
          if (typeof text === 'object') {
             text = text.error || text.message || JSON.stringify(text);
          }
      } else if (errorInfo.message) {
          text = errorInfo.message;
      } else {
          text = 'An unknown error occurred';
      }
  }

  if (!text) text = 'An unknown error occurred';

  const footer = requestId ? `Support ID: <code>${requestId}</code>` : null;

  Swal.fire({
      title: 'Error',
      [isHtml ? 'html' : 'text']: typeof text === 'string' ? text : JSON.stringify(text),
      icon: 'error',
      footer: footer
  });
}

export const swalSuccess = (text, isHtml = false, title = 'Success') =>{
  if (isHtml){
    return Swal.fire({title, html: text, icon: 'success'})
  }else{
    return Swal.fire({title, text, icon: 'success'})
  }
}

export const create_chart_label = (list, count = 0)=>{
  let labels = ['Baseline']
  let increment = 4
  let current = 0
  // list.pop() // bug

  if (count){
    for (let i = 0; i < count; i++) {
      current += increment
      labels.push(`${current}th`)
    }
    return labels
  }

  let shit = [...list]
  shit.pop()
  shit.forEach(x => {
    current += increment
    labels.push(`${current}th`)
  });

  return labels
}

export const parse_meta_key = (items)=>{
  let x = items.reduce((acc, obj) => {
    acc[obj.attributes.key] = obj.attributes.value;
    return acc;
  }, {});
  return x
}

export const get_meta = (metas, key)=>{
  let meta = metas.find(item=>item.attributes.key == key)
  if (key == 'features'){
    return JSON.parse(meta.attributes.value)
  }
  return meta.attributes.value
}

export const parse_child_meta = (metas)=>{
  const metaArray = Object.keys(metas).map(key => {
    return { key: key, value: metas[key] };
  });
  
  return metaArray
}

export function parse_notification_response(response, included){
  let tempNotifications = response.map(notification => {
    let entity_type = included
                      .filter(item => item.type == 'entity_type')
                      .find(item => item.id == notification.attributes.entity_type_id)
    let actor = included
                      .filter(item => item.type == 'user')
                      .find(item => item.id == notification.attributes.actor_id)
    let meta = parse_meta_key(included.filter(item => item.type == 'notification_metum' && item.attributes.notification_id == notification.id))
    meta = {
      ...meta, 
      account_name: 'You'
    }
    return {
      ...notification,
      entity_type,
      meta
    }
  })
  return tempNotifications
}

export function parse_notification_description(notification){
  let { description } = notification.entity_type.attributes;
  const meta = notification.meta;
  meta.account_name = 'Your'

  // Replace placeholders in the description
  Object.keys(meta).forEach(key => {
    const placeholder = `$${key}`;
    description = description.replace(placeholder, meta[key]);
  });
  return description
}

const now = ref(dayjs(new Date()))
export function subs_time(start_date, sub_duration){
  let time = 'Error'
  let temp_start_date = dayjs(start_date)
  let end_date = temp_start_date.add(sub_duration, 'day')
  let temp = end_date.diff(now.value)
  if (temp < 0){
    return time = "Expired"
  }
  let diff = dayjs.duration(end_date.diff(now.value))
  let months = diff.months();
  let days = diff.days();
  let hours = diff.hours();
  let minutes = diff.minutes();
  let parts = [];
  if (months > 0) parts.push(`${months} months`);
  if (days > 0) parts.push(`${days} days`);
  if (hours > 0) parts.push(`${hours} hours`);
  if (minutes > 0) parts.push(`${minutes} minutes`);
  
  time = parts.length > 0 ? parts.join(' ') : 'Less than a minute';
  return time
}

export function diff_duration(from_date, end_date = '', format = ''){
  from_date = dayjs(from_date)
  end_date = end_date == '' ? now.value : dayjs(end_date)
  let diff = end_date.diff(from_date, format)
  return diff
}

export const numberWithCommas = (value) =>{
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}



// Confetti Animation
const Utils = {
  // Parse pixel values to numeric values
  parsePx: (value) => parseFloat(value.replace(/px/, "")),

  // Generate a random number between two values, optionally with a fixed precision
  getRandomInRange: (min, max, precision = 0) => {
    const multiplier = Math.pow(10, precision);
    const randomValue = Math.random() * (max - min) + min;
    return Math.floor(randomValue * multiplier) / multiplier;
  },

  // Pick a random item from an array
  getRandomItem: (array) => array[Math.floor(Math.random() * array.length)],

  // Scaling factor based on screen width
  getScaleFactor: () => Math.log(window.innerWidth) / Math.log(1920),

  // Debounce function to limit event firing frequency
  debounce: (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  },
};

// Precomputed constants
const DEG_TO_RAD = Math.PI / 180;

// Centralized configuration for default values
const defaultConfettiConfig = {
  confettiesNumber: 250,
  confettiRadius: 6,
  confettiColors: [
    "#fcf403", "#62fc03", "#f4fc03", "#03e7fc", "#03fca5", "#a503fc", "#fc03ad", "#fc03c2"
  ],
  emojies: [],
  svgIcon: null, // Example SVG link
};

// Confetti class representing individual confetti pieces
class Confetti {
  constructor({ initialPosition, direction, radius, colors, emojis, svgIcon }) {
    const speedFactor = Utils.getRandomInRange(0.9, 1.7, 3) * Utils.getScaleFactor();
    this.speed = { x: speedFactor, y: speedFactor };
    this.finalSpeedX = Utils.getRandomInRange(0.2, 0.6, 3);
    this.rotationSpeed = emojis.length || svgIcon ? 0.01 : Utils.getRandomInRange(0.03, 0.07, 3) * Utils.getScaleFactor();
    this.dragCoefficient = Utils.getRandomInRange(0.0005, 0.0009, 6);
    this.radius = { x: radius, y: radius };
    this.initialRadius = radius;
    this.rotationAngle = direction === "left" ? Utils.getRandomInRange(0, 0.2, 3) : Utils.getRandomInRange(-0.2, 0, 3);
    this.emojiRotationAngle = Utils.getRandomInRange(0, 2 * Math.PI);
    this.radiusYDirection = "down";

    const angle = direction === "left" ? Utils.getRandomInRange(82, 15) * DEG_TO_RAD : Utils.getRandomInRange(-15, -82) * DEG_TO_RAD;
    this.absCos = Math.abs(Math.cos(angle));
    this.absSin = Math.abs(Math.sin(angle));

    const offset = Utils.getRandomInRange(-150, 0);
    const position = {
      x: initialPosition.x + (direction === "left" ? -offset : offset) * this.absCos,
      y: initialPosition.y - offset * this.absSin
    };

    this.position = { ...position };
    this.initialPosition = { ...position };
    this.color = emojis.length || svgIcon ? null : Utils.getRandomItem(colors);
    this.emoji = emojis.length ? Utils.getRandomItem(emojis) : null;
    this.svgIcon = null;

    // Preload SVG if provided
    if (svgIcon) {
      this.svgImage = new Image();
      this.svgImage.src = svgIcon;
      this.svgImage.onload = () => {
        this.svgIcon = this.svgImage; // Mark as ready once loaded
      };
    }

    this.createdAt = Date.now();
    this.direction = direction;
  }

  draw(context) {
    const { x, y } = this.position;
    const { x: radiusX, y: radiusY } = this.radius;
    const scale = window.devicePixelRatio;

    if (this.svgIcon) {
      context.save();
      context.translate(scale * x, scale * y);
      context.rotate(this.emojiRotationAngle);
      context.drawImage(this.svgIcon, -radiusX, -radiusY, radiusX * 2, radiusY * 2);
      context.restore();
    } else if (this.color) {
      context.fillStyle = this.color;
      context.beginPath();
      context.ellipse(x * scale, y * scale, radiusX * scale, radiusY * scale, this.rotationAngle, 0, 2 * Math.PI);
      context.fill();
    } else if (this.emoji) {
      context.font = `${radiusX * scale}px serif`;
      context.save();
      context.translate(scale * x, scale * y);
      context.rotate(this.emojiRotationAngle);
      context.textAlign = "center";
      context.fillText(this.emoji, 0, radiusY / 2); // Adjust vertical alignment
      context.restore();
    }
  }

  updatePosition(deltaTime, currentTime) {
    const elapsed = currentTime - this.createdAt;

    if (this.speed.x > this.finalSpeedX) {
      this.speed.x -= this.dragCoefficient * deltaTime;
    }

    this.position.x += this.speed.x * (this.direction === "left" ? -this.absCos : this.absCos) * deltaTime;
    this.position.y = this.initialPosition.y - this.speed.y * this.absSin * elapsed + 0.00125 * Math.pow(elapsed, 2) / 2;

    if (!this.emoji && !this.svgIcon) {
      this.rotationSpeed -= 1e-5 * deltaTime;
      this.rotationSpeed = Math.max(this.rotationSpeed, 0);

      if (this.radiusYDirection === "down") {
        this.radius.y -= deltaTime * this.rotationSpeed;
        if (this.radius.y <= 0) {
          this.radius.y = 0;
          this.radiusYDirection = "up";
        }
      } else {
        this.radius.y += deltaTime * this.rotationSpeed;
        if (this.radius.y >= this.initialRadius) {
          this.radius.y = this.initialRadius;
          this.radiusYDirection = "down";
        }
      }
    }
  }

  isVisible(canvasHeight) {
    return this.position.y < canvasHeight + 100;
  }
}

class ConfettiManager {
  constructor() {
    this.canvas = document.createElement("canvas");
    this.canvas.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 1000; pointer-events: none;";
    document.body.appendChild(this.canvas);
    this.context = this.canvas.getContext("2d");
    this.confetti = [];
    this.lastUpdated = Date.now();
    window.addEventListener("resize", Utils.debounce(() => this.resizeCanvas(), 200));
    this.resizeCanvas();
    requestAnimationFrame(() => this.loop());
  }

  resizeCanvas() {
    this.canvas.width = window.innerWidth * window.devicePixelRatio;
    this.canvas.height = window.innerHeight * window.devicePixelRatio;
  }

  addConfetti(config = {}) {
    const { confettiesNumber, confettiRadius, confettiColors, emojies, svgIcon } = {
      ...defaultConfettiConfig,
      ...config,
    };

    const baseY = (5 * window.innerHeight) / 7;
    for (let i = 0; i < confettiesNumber / 2; i++) {
      this.confetti.push(new Confetti({
        initialPosition: { x: 0, y: baseY },
        direction: "right",
        radius: confettiRadius,
        colors: confettiColors,
        emojis: emojies,
        svgIcon,
      }));
      this.confetti.push(new Confetti({
        initialPosition: { x: window.innerWidth, y: baseY },
        direction: "left",
        radius: confettiRadius,
        colors: confettiColors,
        emojis: emojies,
        svgIcon,
      }));
    }
  }

  resetAndStart(config = {}) {
    // Clear existing confetti
    this.confetti = [];
    // Add new confetti
    this.addConfetti(config);
  }

  loop() {
    const currentTime = Date.now();
    const deltaTime = currentTime - this.lastUpdated;
    this.lastUpdated = currentTime;

    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

    this.confetti = this.confetti.filter((item) => {
      item.updatePosition(deltaTime, currentTime);
      item.draw(this.context);
      return item.isVisible(this.canvas.height);
    });

    requestAnimationFrame(() => this.loop());
  }
}

export const confettiClass = new ConfettiManager();
// End Confetti Animation

export function getInvStatusColor(status) {
  const colors = {
    succeeded: 'success',
    pending: 'warning',
    overdue: 'danger',
    draft: 'secondary'
  }
  return colors[status] || 'secondary'
}